import React from "react"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Separator } from "@/components/ui/separator"
import { Application } from "@/contexts/ApplicationContext"

interface ReferenceDriverSectionProps {
  application: Application
  setApplication: (app: Application) => void
}

const ReferenceDriverSection: React.FC<ReferenceDriverSectionProps> = ({
  application,
  setApplication,
}) => {
  return (
    <div className="mb-6 space-y-4">
      <div className="flex items-center px-6 pt-6">
        <h2 className="text-lg font-bold text-jungle">Reference Driver</h2>
      </div>
      <Separator className="mt-2" />

      <div className="bg-transparent p-6">
        <div className="space-y-2">
          <Label htmlFor="referenceDriverId" className="text-sm md:text-base">
            Reference Driver ID
          </Label>
          <Input
            id="referenceDriverId"
            value={application.referenceDriverId || ""}
            onChange={(e) =>
              setApplication({
                ...application,
                referenceDriverId: e.target.value,
              })
            }
            placeholder="Enter Reference Driver ID"
            className="w-full bg-white"
          />
          <div className="text-xs text-gray-500">
            If you were referred by an existing driver, please enter their Driver ID
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReferenceDriverSection
